import FadeShow from "./fadeshow";
import { createApp } from 'vue';
import App from './App.vue';

declare global {
  interface Window {
    createFadeShow: any;
  }
}

function createFadeShow(parentId: string, slides: string[])
{
	new FadeShow(parentId, slides);
}

window.addEventListener('load', () => {
	const mobileMenu = document.getElementById('mobile_menu');
	const mobileMenuBtn = document.getElementById('mobile_menu_btn');
	const closeMobileMenuBtn = document.getElementById('close_mobile_menu_btn');
  mobileMenuBtn?.addEventListener('click', () => {
	
    mobileMenu?.classList.remove('mobile_menu_close');
    mobileMenu?.classList.add('mobile_menu_open');
  });
  closeMobileMenuBtn?.addEventListener('click', () => {
    mobileMenu?.classList.remove('mobile_menu_open');
    mobileMenu?.classList.add('mobile_menu_close');
  });

  if (document.getElementById('app')) {
    createApp(App).mount('#app');
  }
});

window.createFadeShow = createFadeShow;